import React, { lazy } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from './Components/Navbar';
import Footer from './Components/footer';
import ScrollToTop from './Components/ScrollToTop';
import ProtectedRoute from './Components/Security/ProtectedRoute';
import { HelmetProvider } from 'react-helmet-async';


// Lazy loading des composants lourds (pages)
const Home = lazy(() => import('./Pages/Home'));
const Login = lazy(() => import('./Pages/Login'));
const AdminPage = lazy(() => import('./Pages/AdminPage'));
const Blog = lazy(() => import('./Pages/Blog'));
const Réalisations = lazy(() => import('./Pages/page'));
const NousDécouvrir = lazy(() => import('./Pages/NousDécouvrir'));
const Contact = lazy(() => import('./Pages/Contacter'));
const NotreMission = lazy(() => import('./Pages/NotreMission'));
const MentionsLegales = lazy(() => import('./Pages/MentionsLegales'));
const Industriel = lazy(() => import('./Components/Industriel'));
const Logistique = lazy(() => import('./Components/Logistiques'));
const Retail = lazy(() => import('./Components/Retail'));
const Tertiaire = lazy(() => import('./Components/Tertiaire'));
const Sportif = lazy(() => import('./Components/Sportif'));
const EclairagePublic = lazy(() => import('./Components/EclairagePublic'));
const Secteur = lazy(() => import('./Components/Secteur'));
const SNCFTrappes = lazy(() => import('./Components/SNCF-Trappes'));
const Heppner = lazy(() => import('./Components/Heppner'));
const Elior = lazy(() => import('./Components/Elior'));
const Gymnase = lazy(() => import('./Components/Gymnase Fernand Ganne'));
const NotFound = lazy(() => import('./Pages/NotFound'));
const Coubron = lazy(() => import('./Components/Coubron'));
const CookieConsent = lazy(() => import('./Components/CookieConsent'));
const Galerie = lazy(() => import('./Pages/Galerie'));
const MieuxConnaitre = lazy(() => import('./Components/MieuxConnaitre'));




const NosClients = lazy(() => import('./Components/NosClients'));





const ArticleDetailPage = lazy(() => import('./Components/ArticleDetailPage'));



const AppContent = () => {
  const location = useLocation();
  const hideGlobalComponents = ["/Nossecteurs", "/", "/Logistiques", "/Industriel", "/Tertiaire", "/Sportif", "/EclairagePublic", "/Retail"];


  return (
    <>
      {!hideGlobalComponents.includes(location.pathname) && <Navbar />}
      <ScrollToTop />
      <HelmetProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/Réalisations" element={<Réalisations />} />
        <Route path="/NousDécouvrir" element={<NousDécouvrir />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Mentions-legales" element={<MentionsLegales />} />
        <Route path="/Galerie" element={<Galerie />} />

        <Route path="/notre-mission" element={<NotreMission />} />
        <Route path="/Nossecteurs" element={<Secteur />} />
        <Route path="/Secteurs/Industriel" element={<Industriel />} />
        <Route path="/Secteurs/Logistique" element={<Logistique />} />
        <Route path="/Secteurs/Retail" element={<Retail />} />
        <Route path="/Secteurs/Tertiaire" element={<Tertiaire />} />
        <Route path="/Secteurs/Sportif" element={<Sportif />} />
        <Route path="/Secteurs/EclairagePublic" element={<EclairagePublic />} />
        <Route path="/SNCF-Trappes" element={<SNCFTrappes />} />
        <Route path="/Heppner" element={<Heppner />} />
        <Route path="/NosClients" element={<NosClients />} />
        <Route path="/Elior" element={<Elior />} />
        <Route path="/Coubron" element={<Coubron />} />
        <Route path="/NotreMission" element={<NotreMission />} />
        <Route path="/Gymnase Fernand Ganne" element={<Gymnase />} />
        <Route path="/wp-content/uploads/2024/06/Mieux-Connaitre-LSL-2024.pdf" element={<MieuxConnaitre />} />
        


        <Route path="/articles/:section/:slug" element={<ArticleDetailPage />} />
        <Route path="*" element={<NotFound />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      </HelmetProvider>
      <CookieConsent />  

      <ConditionalFooter />
    </>
  );
};

const ConditionalFooter = () => {
  const location = useLocation();
  if (
    location.pathname === "/admin" ||
    location.pathname === "/login" ||
    location.pathname === "/Nossecteurs" ||
    location.pathname === "/wp-content/uploads/2024/06/Mieux-Connaitre-LSL-2024.pdf" 
  ) {
    return null;
  }
  return <Footer />;
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;